import axios from 'axios';
import store from 'store';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

const requestInterceptor = (config) => {
  let token = store.get('token');
  config.headers['Authorization'] = `Bearer ${token}`;
  return config;
};
const responseInterceptor = (response) => response.data;

const errorHandler = (error) => {
  if (error) {
    if (error.response) {
      const errorMessage = error.response.data && error.response.data.message;
      return Promise.reject(errorMessage);
    } else {
      return Promise.reject(error.message);
    }
  }
};

apiClient.interceptors.request.use(requestInterceptor, errorHandler);
apiClient.interceptors.response.use(responseInterceptor, errorHandler);

export const signUp = (data) => apiClient.post('/auth/register', data);
export const login = (data) => apiClient.post('/auth/login', data);
export const transfer = (data) => apiClient.post('/transfer', data);
export const fetchUser = () => apiClient.get('/user');
export const fetchBalance = () => apiClient.get('/balance');
export const fetchTransactions = () => apiClient.get('/transactions');
